import LocationSettingsStore from './LocationSettingsStore'

export default LocationSettingsStore
